<template lang="pug">
  div(
    class="error-card"
    :style="cardStyle"
  )
    div(class="error-card__image")
      v-img(
        :src="image.src"
        :max-width="image.width"
      )
    div(class="error-card__content")
      h2(
        v-if="title"
        class="title-24px mb-2"
      ) {{ title }}
      p(
        v-if="text"
        class="text-16px dark error-card__subtitle"
      ) {{ text }}
    div(class="error-card__actions pt-8")
      v-btn(
        class="main-button"
        @click="handleButtonClick"
      ) {{ buttonText }}
    slot(name="bottom")
</template>

<script>
import authData from '~/modules/auth/mixins/authData'

export default {
  name: 'MBlockErrorCard',
  mixins: [authData],
  props: {
    cardMaxWidth: {
      type: [Number, String],
      default: 500
    },
    image: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    buttonText: {
      type: String,
      default: null
    }
  },
  computed: {
    cardStyle() {
      return {
        maxWidth:
          typeof this.cardMaxWidth === 'number' ? this.cardMaxWidth + 'px' : this.cardMaxWidth
      }
    }
  },
  methods: {
    handleButtonClick() {
      if (this.authToken) {
        this.$router.push('/documents')
      } else {
        this.$router.push('/auth')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.error-card {
  width: 100%;

  padding: 40px;

  display: flex;
  flex-direction: column;
  align-items: center;

  border-radius: 28px;
  background: #fff;
  text-align: center;

  &__image {
    padding-bottom: 16px;
  }

  &__subtitle {
    max-width: 380px;
  }
}
</style>
